const HASHRATE_SUFFIXES = [
  "H/s",
  "KH/s",
  "MH/s",
  "GH/s",
  "TH/s",
  "PH/s",
  "EH/s",
  "ZH/s",
  "YH/s",
];

export function resolveHashrateDisplayScale(
  values: number[],
  suffix: string
): { factor: number; suffix: string } {
  const suffixIndex = findHashrateSuffixIndex(suffix);
  if (suffixIndex == -1) {
    return {
      factor: 1,
      suffix,
    };
  }

  const maxAbsValue = values.reduce((max, value) => {
    if (!Number.isFinite(value)) return max;
    return Math.max(max, Math.abs(value));
  }, 0);
  if (maxAbsValue <= 0) {
    return {
      factor: 1,
      suffix,
    };
  }

  let targetIndex = suffixIndex;
  let scaledMaxValue = maxAbsValue;

  while (scaledMaxValue < 1 && targetIndex > 0) {
    scaledMaxValue *= 1000;
    targetIndex -= 1;
  }

  while (scaledMaxValue >= 1000 && targetIndex < HASHRATE_SUFFIXES.length - 1) {
    scaledMaxValue /= 1000;
    targetIndex += 1;
  }

  return {
    factor: Math.pow(1000, suffixIndex - targetIndex),
    suffix: HASHRATE_SUFFIXES[targetIndex],
  };
}

function findHashrateSuffixIndex(suffix: string): number {
  const normalizedSuffix = String(suffix ?? "").trim().toUpperCase();
  return HASHRATE_SUFFIXES.findIndex(
    (value) => value.toUpperCase() == normalizedSuffix
  );
}
